<template>
  <el-container>
    <el-header style="height: 40px;line-height: 40px;">
      <el-row>
        <el-col :span="6" style="text-align: left;"><el-button type="primary" size="small" round
            @click="openDialog(null)">添加</el-button></el-col>
            <el-col :span="3" style="text-align: left;">
             <el-input placeholder="请输入产品编码" v-model="searchCode" style="display: inline;margin-left: 5px; "
                      clearable required>
                    </el-input>
            </el-col>
            
            <el-col :span="15" style="text-align: left;">
              <el-button type="success" size="small" round
            @click="searchProduct" style="margin-left: 10px;">查询</el-button>
            </el-col>
      </el-row>
    </el-header>
    <el-container>
      <el-container>
        <el-main style="padding: 0;">
          <el-table :data="paginatedData" style="border: none;min-height: 400px;height: calc(100%-300px);"
            @row-click="handleRowClick" class="custom-table" :row-style="{ 'max-height': '60px' }">
            <el-table-column prop="mainCode" label="系列编码" width="120">
            </el-table-column>
            <el-table-column prop="code" label="产品编码" width="140">
            </el-table-column>
            <el-table-column prop="typeName" label="产品类型" width="100">
            </el-table-column>
            <el-table-column prop="name" label="产品简介" width="180">
            </el-table-column>
            <el-table-column label="详情" width="420">
              <template #default="scope">
                <div class="cell-ellipsis" v-html="scope.row.remark"></div>
              </template>
            </el-table-column>
            <el-table-column prop="isNew" label="新品" width="50">
            </el-table-column>
            <el-table-column prop="isMain" label="主页" width="50">
            </el-table-column>
            <el-table-column prop="date" label="录入日期" width="120">
            </el-table-column>
            <el-table-column prop="happenDate" label="生效日期" width="120">
            </el-table-column>
            <!-- <el-table-column prop="isAudit" label="状态" >
            </el-table-column>
            <el-table-column prop="auditDate" label="审核日期">
            </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">

                <el-row>
                  <el-button type="primary" size="mini" icon="el-icon-edit" circle
                    @click="openDialog(scope.row)"></el-button>
                  <el-button type="danger" size="mini" icon="el-icon-delete" circle
                    @click="deleteProduct(scope.row.id)"></el-button>
                  <el-button type="primary" size="mini" icon="el-icon-upload2" circle
                    @click="showUpload(scope.row)"></el-button>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next" :hide-on-single-page="value" :total="totalData"
            :page-size="pageSize" @current-change="handleCurrentChange" :current-page="currentPage">
          </el-pagination>
          <el-table :data="currentData" style="min-height: 300px;" :border="false">
            <el-table-column prop="Length" label="Length">
            </el-table-column>
            <el-table-column prop="Depth" label="Depth" width="140">
            </el-table-column>
            <el-table-column prop="Height" label="Height" width="120">
            </el-table-column>

            <el-table-column prop="LEDs" label="LEDPower">
            </el-table-column>

            <el-table-column prop="Voltage" label="Voltage">
            </el-table-column>
            <el-table-column prop="LED Color" label="Weight">
            </el-table-column>
            <el-table-column prop="MaxPower" label="MaxPower">
            </el-table-column>
            <el-table-column prop="Beam" label="Beam">
            </el-table-column>
            <el-table-column prop="Lumes" label="Lumes">
            </el-table-column>
            <el-table-column prop="function" label="Flash Pattern/Function">
            </el-table-column>
            <el-table-column prop="Certification" label="Certification">
            </el-table-column>
            <el-table-column prop="IPRating" label="IPRating">
            </el-table-column>
            <el-table-column prop="remark" label="remark">
            </el-table-column>
          </el-table>
          <!-- 弹窗 -->
          <div v-if="isDialogVisible" class="dialog-mask">
            <div class="dialog-content">
              <h3 style="margin-bottom: 20px;">{{ isEditMode ? '修改' : '新增' }}</h3>
              <table class="editTable">
                <tr>
                  <td class="lableTd">
                    产品编码
                  </td>
                  <td>
                    <el-input placeholder="请输入产品编码" v-model="popData.code" style="display: inline;margin-left: 5px; "
                      clearable required>
                    </el-input>
                  </td>
                  <td class="lableTd">
                    产品简介
                  </td>
                  <td>
                    <el-input placeholder="请输入产品简介" v-model="popData.name"
                      style="display: inline;margin-left: 5px;"></el-input>
                  </td>
                  <td class="lableTd">
                    生效日期
                  </td>
                  <td>
                    <el-date-picker style="margin-left: 5px; width: 100%;" v-model="popData.happenDate" type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </td>
                </tr>

                <tr>
                  <td class="lableTd">
                    产品系列
                  </td>
                  <td>
                    <el-select v-model="popData.mainCodeID" placeholder="请选择系列" ref="sMainCode"
                      @change="mainCodeSelectValueChange" style="margin-left: 5px; width: 100%;">
                      <el-option v-for="option in listMainCode" :key="option.id" :label="option.name"
                        :value="option.id">
                      </el-option>
                    </el-select>
                  </td>
                  <td class="lableTd">
                    产品类型
                  </td>
                  <td>
                    <DropDownTree :data="typeList" :defaultProps="dropProps" :selectValue="popData.typeID"
                      ref="typeTree" @update:selectID="typeSelectValueChange" style="margin-left: 5px; width: 235px;">
                    </DropDownTree>
                  </td>
                  <td class="lableTd">
                    是否新品
                  </td>
                  <td>
                    <el-select v-model="popData.isNew" placeholder="请选择" style="margin-left: 5px; width: 100%;">
                      <el-option v-for="option in listIsnew" :key="option.id" :label="option.name" :value="option.id">
                      </el-option>
                    </el-select>
                  </td>
                </tr>
                <tr>
                  <td class="lableTd">
                    是否主页
                  </td>
                  <td>
                    <el-select v-model="popData.isMain" placeholder="请选择" style="margin-left: 5px; width: 100%;">
                      <el-option v-for="option in listIsnew" :key="option.id" :label="option.name" :value="option.id">
                      </el-option>
                    </el-select>
                  </td>
                  <td class="lableTd">
                    是否产品页
                  </td>
                  <td>
                    <el-select v-model="popData.isProduct" placeholder="请选择" style="margin-left: 5px; width: 100%;">
                      <el-option v-for="option in listIsnew" :key="option.id" :label="option.name" :value="option.id">
                      </el-option>
                    </el-select>
                  </td>
                  
                  <td class="lableTd">
                    尺寸(in)
                  </td>
                  <td>
                    <el-input v-model="popData.inSize" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                </tr>
                <tr>
                  <td class="lableTd">
                    产品链接
                  </td>
                  <td colspan="3">
                    <el-input v-model="popData.tubeUrl" style="display: inline;margin-left: 5px;"></el-input>
                  </td>
                  <td class="lableTd">
                    主产品排序
                  </td>
                  <td >
                    <el-input v-model="popData.mainSort" style="display: inline;margin-left: 5px;"></el-input>
                  </td>
                </tr>
                <tr style="height: 190px;">
                  <td class="lableTd">
                    产品详情
                  </td>
                  <td colspan="5">
                    <!-- <vue-editor v-model="popData.remark" :options="editorOptions"></vue-editor> -->
                    <ckeditor v-model="popData.remark" :config="editorConfig"></ckeditor>
                  </td>

                </tr>
                <tr>
                  <td class="lableTd">
                    Length(mm)
                  </td>
                  <td>
                    <el-input v-model="popData.length" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                  <td class="lableTd">
                    Depth(mm)
                  </td>
                  <td>
                    <el-input v-model="popData.depth" style="display: inline;margin-left: 5px; "></el-input>
                  </td>

                  <td class="lableTd">
                    Height(mm)
                  </td>
                  <td>
                    <el-input v-model="popData.height" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                </tr>
                <tr>


                  <td class="lableTd">
                    LEDs
                  </td>
                  <td>
                    <el-input v-model="popData.ledPower" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                  <td class="lableTd">
                    Voltage
                  </td>
                  <td>
                    <el-input v-model="popData.voltage" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                  <td class="lableTd">
                    LED Color
                  </td>
                  <td>
                    <el-input v-model="popData.weight" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                </tr>
                <tr>
                  <td class="lableTd">
                    Max Power
                  </td>
                  <td>
                    <el-input v-model="popData.maxPower" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                  <td class="lableTd">
                    Beam
                  </td>
                  <td>
                    <el-input v-model="popData.beam" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                  <td class="lableTd">
                    Lumes
                  </td>
                  <td>
                    <el-input v-model="popData.lumes" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                </tr>
                <tr>
                  <td class="lableTd">
                    Flash Pattern/Function
                  </td>
                  <td>
                    <el-input v-model="popData.function" style="display: inline;margin-left: 5px; " clearable
                      required></el-input>
                  </td>
                  <td class="lableTd">
                    Certification
                  </td>
                  <td>
                    <el-input v-model="popData.certification" style="display: inline;margin-left: 5px; " clearable
                      required></el-input>
                  </td>
                  <td class="lableTd">
                    IP Rating
                  </td>
                  <td>
                    <el-input v-model="popData.ipRating" style="display: inline;margin-left: 5px; "></el-input>
                  </td>
                  <td>

                  </td>
                </tr>

                <tr>
                  <td class="lableTd">
                    封面图 <br> 320*276
                  </td>
                  <td>
                    <el-upload class="avatar-uploader" action="" :show-file-list="false" :file-list="coverList"
                      :before-upload="handleBeforeUpload" :on-change="coverFileChange">
                      <img v-if="coverUrl" :src="coverUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </td>
                  <td class="lableTd">
                    首页主图
                  </td>
                  <td>
                    <el-upload class="avatar-uploader" action="" :show-file-list="false" :file-list="fileList"
                      :before-upload="handleBeforeUpload" :on-change="mainFileChange">
                      <img v-if="mainUrl" :src="mainUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </td>
                  <td class="lableTd">
                    首页切换图
                  </td>
                  <td>
                    <el-upload class="avatar-uploader" action="" :show-file-list="false" :file-list="hoverList"
                      :before-upload="handleBeforeUpload" :on-change="hoverFileChange">
                      <img v-if="hoverUrl" :src="hoverUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </td>
                </tr>

              </table>
              <div class="button-group">
                <el-button size="mini" round @click="saveProduct">确认</el-button>
                <el-button size="mini" round @click="closeDialog">取消</el-button>
              </div>
            </div>
          </div>
        </el-main>
        <el-aside width="160px">
          <div>
            <el-upload action="" class="upload-demo" ref="upload" :on-preview="handlePreview" :on-remove="handleRemove"
              :on-change="handleFileChange" :file-list="files" multiple :auto-upload="false">
              <el-button slot="trigger" v-if="isDialogUpload" size="small" type="primary">选取文件</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" v-if="files.length != 0"
                @click="uploadFiles">上传到服务器</el-button>
            </el-upload>
          </div>
          <div v-for=" (file,index) in picList" :key="file.id" style="display: flex;width: 320px;position: relative;">
            <img :src="file.img" alt="" style="max-width: 200px;max-height: 190px;padding-bottom: 20px;">
            <div style="position: absolute;margin-left: 8px; max-height: 15px;left: 10px;top: 5px;">
              <span @click="delPic(index,file.id)">X</span>
            </div>
          </div>
        </el-aside>
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
  // import { VueEditor } from "vue2-editor";
  import DropDownTree from '../../../src/components/common/DropDownTree.vue';
  import { upLoadFile, delPicInfo } from "@/api/rbac/upload";
  import { getProductType, getProductMain, getProductMainCode, addProduct, delProductInfo, getProductPic } from "@/api/rbac/product";
  // import {arrayToTree} from "@/api/rbac/transChildren";

  export default {

    created() {
      this.loadDataList('');
      this.getTypeList();
      this.getMainCodeList();
    },
    components: {
      DropDownTree,
      // VueEditor,
    },
    data() {
      return {
        editorConfig: {
                    extraPlugins: 'font,colorbutton', // 添加字体和颜色插件
                    toolbar: [
                        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
                        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                        { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                        { name: 'colors', items: ['TextColor', 'BGColor'] },
                        // { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 视频功能
                        { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 添加图片按钮
                        { name: 'links', items: ['Link', 'Unlink'] },
                    ],
                    font_names: 'Arial/Arial, Helvetica, sans-serif;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
                    fontSize_sizes: '9/9px;11/11px;13/13px;16/16px;18/18px;21/21px;24/24px;28/28px;32/32px',
                    language: 'zh-cn'
                },
        selectedValue: 0, // 绑定的变量
        selectTypeName: '', // 绑定的变量
        dataList: [],
        currentData: [{ IPRating: '', Lumes: '', Beam: '', MaxPower: '', Voltage: '', Length: '', LEDPower: '', Weight: '', Height: '', Depth: '' }],
        listMainCode: [],
        listIsnew: [{ id: 1, name: '是' }, { id: 0, name: '否' }],
        popData: {
          id: 0, name: '', typeID: 0, code: '', isNew: 0, maincodeID: 0, operaterID: 0, date: new Date()
          , heppenDate: new Date(), typeName: '', maincode: '', operaterMan: '', depth: '', height: '', length: '', weight: '', ledPower: ''
          , voltage: '', maxPower: '', beam: '', lumes: '', function: '', certification: '', ipRating: '', detailID: 0, isAudit: 0
          , remark: '', sort: 0, isMain: 0, tubeUrl: '', inSize: '', isProduct: 1,mainSort:null,
        },
        isDialogVisible: false,
        isDialogUpload: false,

        dialogImageUrl: '',
        dialogVisible: false,
        isEditMode: false,
        typeList: [],
        dropProps: {
          children: "children",
          label: "name",
        },
        files: [],
        strPath: '',
        picList: [],
        coverList: [],//封面图
        fileList: [],//首页主图
        hoverList: [],//首页切换图
        coverUrl: '',
        mainUrl: '',
        hoverUrl: '',
        // 当前页码
				currentPage: 1,
				// 每页显示的数据条数
				pageSize: 10,
				// 总数据条数
				totalData: 0,
				value: true,
        searchCode:'',//查询的产品编码
        isFirstOpen: true,
      }
    },
    watch: {
      filterText(val) {
        this.$refs.selecteltree.filter(val);
      },
    },
    methods: {
      // 当前页码改变时的处理函数
			handleCurrentChange(page) {
				this.currentPage = page;
			},
      async loadDataList(strWhere) {
        try {
          getProductMain({ strWhere: strWhere }).then(res => {
            if (res.data.length == 0) {
              // console.log(this.dataList)
              this.dataList =[]
            }
            else {
              this.dataList = res.data;
              
            }
            this.totalData=this.dataList.length
            // this.searchCode=''
          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
      //保存
      async saveProduct() {
        if (!String(this.popData.name).trim()) {
          return alert("描述为空")
        }
        else if (!String(this.popData.code).trim()) {
          return alert("编码为空")
        }
        else if (!String(this.popData.heppenDate).trim()) {
          return alert("生效日期为空")
        }
        else if (!String(this.popData.maincodeID).trim()||String(this.popData.maincodeID) =='0') {
          return alert("请选择系列")
        }
        else if (!String(this.popData.typeID).trim()||this.popData.typeID==0) {
          return alert("请选择类型")
        }
        // else if (!String(this.popData.inSize).trim()) {
        //   return alert("请输入尺寸")
        // }
        else if (!String(this.popData.remark).trim()) {
          return alert("请输入详情")
        }
        else {
          try {
            // 使用正则表达式去除 HTML 标签
            // this.popData.remark = this.popData.remark.replace(/<\/?[^>]+(>|$)/g, "");

            addProduct(this.popData).then(res => {

              if (res.data.success) {
                //上传封面图
                if (this.coverList.length > 0) {
                  const formCover = new FormData();
                  this.coverList.forEach((file) => {
                    formCover.append('files[]', file.raw);
                  });
                  formCover.append("strType", "pCover")
                  formCover.append("partID", res.data.id)
                  upLoadFile(formCover).then(pCover => {
                    if (pCover.data.success) {

                      // alert('封面图上传成功');
                    }
                    else {
                      //  this.dataList=res.data;
                      alert('封面图上传失败');
                    }
                  })
                }
                //上传主页主图
                if (this.fileList.length > 0) {
                  const formMain = new FormData();
                  this.fileList.forEach((file) => {
                    formMain.append('files[]', file.raw);
                  });
                  formMain.append("strType", "pHomeMain")
                  formMain.append("partID", res.data.id)
                  upLoadFile(formMain).then(pMain => {
                    if (pMain.data.success) {
                      // alert('主页主图上传成功');
                    }
                    else {
                      alert('主页主图上传失败');
                    }
                  })
                }
                //上传主页切换图
                if (this.hoverList.length > 0) {
                  const formHover = new FormData();
                  this.hoverList.forEach((file) => {
                    formHover.append('files[]', file.raw);
                  });
                  formHover.append("strType", "pHomehover")
                  formHover.append("partID", res.data.id)
                  upLoadFile(formHover).then(pMain => {
                    if (pMain.data.success) {
                      // alert('主页切换图上传成功');
                    }
                    else {
                      alert('主页切换图上传失败');
                    }
                  })
                }
                this.coverList = [];
                this.fileList = [];
                this.hoverList = [];
                this.coverUrl = "";
                this.mainUrl = '';
                this.hoverUrl = '';
                var strWhere=''

                if (this.searchCode!='') {
                  strWhere=` and a.code like'%${this.searchCode}%'`
                }
                this.loadDataList(strWhere);

                this.isDialogVisible = false;
                this.popData = {
                  id: 0, name: '', typeID: 0, code: '', isNew: 0, mainCodeID: 0, operaterID: 0, date: new Date()
                  , heppenDate: new Date(), typeName: '', maincode: '', operaterMan: '', depth: '', height: '', length: '', weight: '', ledPower: ''
                  , voltage: '', maxPower: '', beam: '', lumes: '', function: '', certification: '', ipRating: '', detailID: 0, isAudit: 0
                  , remark: '', sort: 0, isMain: 0, tubeUrl: '', inSize: '', isProduct: 1,mainSort:null,
                };
              }
            })
          } catch (error) {
            console.error('保存失败:', error);
          }
        }

      },

      // async editProduct(product) {
      //   this.currentData = { ...product };
      // },

      async deleteProduct(id) {
        this.$confirm('确定删除该, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          try {
            delProductInfo(id).then(res => {
              if (res.data == "ok") {
                this.loadDataList('');
              }
            })

            this.popData = {
              id: 0, name: '', typeID: 0, code: '', isNew: 0, mainCodeID: 0, operaterID: 0, date: new Date()
              , heppenDate: new Date(), typeName: '', maincode: '', operaterMan: '', depth: '', height: '', length: '', weight: '', ledPower: ''
              , voltage: '', maxPower: '', beam: '', lumes: '', function: '', certification: '', ipRating: '', detailID: 0, isAudit: 0
              , remark: '', sort: 0, isMain: 0, tubeUrl: '', inSize: '', isProduct: 1,mainSort:null,
            };
          } catch (error) {
            console.error('删除失败:', error);
          }
        }).catch(() => {
        });

      },
      //获取类型
      async getTypeList() {
        try {
          getProductType().then((res) => {
            if (res.data.length == 0) {
              console.log("无零件类型")
            }
            else {
              // const listTree=arrayToTree(res.data)
              // this.listType=listTree;
              // this.listType=[{id:1,name:'根节点1',children:[{id:2,name:'节点1'},{id:3,name:'节点2'},]},{id:4,name:'根节点2',children:[{id:5,name:'节点3'},]}]
              this.typeList = res.data;
            }
          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
      // 类型改变
      async typeSelectValueChange(value) {
        // console.log(value)
        this.popData.typeID = value;
        // this.popData.typeName=value;
      },
      //获取系列
      async getMainCodeList() {
        try {
          getProductMainCode().then((res) => {
            if (res.data.length == 0) {
              console.log("无系列信息")
            }
            else {
              this.listMainCode = res.data;
            }
          })
        } catch (error) {
          console.error('获取失败:', error);
        }

      },
      // 系列改变
      async mainCodeSelectValueChange(value) {
        this.popData.mainCodeID = value;
      },
      openDialog(item) {
        this.isDialogVisible = true
        this.isEditMode = !!item

        this.coverUrl = '';
        this.mainUrl = '';
        this.hoverUrl = '';
        // 深拷贝避免直接修改原数据
        if (item) {
          console.log(item)
          this.popData = { ...item }
          // this.selectTypeID=this.popData.typeID;
          this.selectedValue = this.popData.mainCodeID;// 
          this.selectTypeName = this.popData.typeName;
          if (this.popData.coverUrl != null) {
            this.coverUrl = '../../../assets/img/ProductCover/' + this.popData.coverUrl
          }
          if (this.popData.mainUrl != null) {
            this.mainUrl = '../../../assets/img/ProductHome/' + this.popData.mainUrl
          }
          if (this.popData.hoverUrl != null) {
            this.hoverUrl = '../../../assets/img/ProductHome/' + this.popData.hoverUrl
          }
        } else {
          this.popData = {
            id: 0, name: '', typeID: 0, code: '', isNew: 0, mainCodeID: 0, operaterID: 0, date: new Date()
            , heppenDate: new Date(), typeName: '', maincode: '', operaterMan: '', depth: '', height: '', length: '', weight: '', ledPower: ''
            , voltage: '', maxPower: '', beam: '', lumes: '', function: '', certification: '', ipRating: '', detailID: 0, isAudit: 0
            , remark: '', sort: 0, isMain: 0, tubeUrl: '', inSize: '', isProduct: 1
          };
        }
        if (this.isFirstOpen) {
          this.checkInterval = setInterval(() => {
            const dynamicDivs = document.querySelectorAll('.cke_notifications_area');

            if (dynamicDivs.length > 0) {
              dynamicDivs.forEach((div) => {
                div.style.display = 'none'
              });
              clearInterval(this.checkInterval); // 停止轮询
              this.isFirstOpen = false;
              // 可以在这里执行加载后的操作
              // 如果只需要检查一次，可以调用 clearInterval(this.checkInterval);
            }
          }, 100); // 每 500ms 检查一次
        }
      },
      async showUpload(item) {
        this.isDialogUpload = true;
        this.popData = { ...item }
      },
      closeDialog() {
        this.isDialogVisible = false
      },

      //行点击事件
      async handleRowClick(row) {
        this.files = [];
        this.currentData = [{ Depth: row.depth, Height: row.height, Weight: row.weight, LEDPower: row.ledPower, Length: row.length, Voltage: row.voltage, MaxPower: row.maxPower, Beam: row.beam, Lumes: row.lumes, IPRating: row.ipRating }]
        this.getPicList(row.id)
      },
      async getPicList(id) {
        try {
          const params1 = { unionID: id, strType: 'product' }
          this.picList = [];
          getProductPic(params1).then(res => {
            if (res.data.length == 0) {
              // console.log(this.dataList)
            }
            else {
              res.data.forEach((file) => {
                // const path='../../../public/assets/img/Products/'+file.name
                // const imagePath = require(`../../../assets/img/Products/${file.name}`);

                const img = { id: file.id, img: '../../../assets/img/Products/' + file.name }

                this.picList.push(img)
              })
            }
          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
      handleRemove(file, fileList) {
        console.log('222', fileList);
        // this.fileList.splice(this.files.indexOf(fileList), 1);
        this.files.splice(this.files.indexOf(file), 1);
      },
      handlePreview(file) {
        console.log('123', file);
      },
      handleFileChange(file, fileList) {
        this.files = fileList; // 更新文件列表状态以反映最新的文件状态。
      },
      handleFileUpload(event) {
        this.files = Array.from(event.target.files);
      },

      removeFile(index) {
        this.files.splice(index, 1);
      },
      onEnd() {
        // 当拖拽结束时，你可能需要做一些额外的处理，比如重新设置 fileList 以确保顺序正确。
        this.fileList = [...this.fileList]; // 使用扩展运算符创建一个新数组以触发视图更新。

      },
      async uploadFiles() {
        if (this.files.length === 0) {
          alert("请选择至少一个文件");
          return;
        }
        const formData = new FormData();
        this.files.forEach((file) => {
          // formData.append('files[]', file);

          formData.append('files[]', file.raw);
        });
        formData.append("strType", "product")
        formData.append("partID", this.popData.id)
        // this.isUploading = true;
        // this.uploadProgress = 0;
        try {
          upLoadFile(formData).then(res => {
            if (res.data.length == 0) {
              alert('文件上传失败');
            }
            else {
              //  this.dataList=res.data;
              alert('所有文件上传成功');
            }
          })
          // alert('所有文件上传成功');
        } catch (error) {
          console.error('文件上传失败', error);
          alert('文件上传失败');
        } finally {
          // this.isUploading = false;
        }
        this.files = [];
      },

      handleBeforeUpload(file) {
        console.log(file)
        // 返回 false 阻止自动上传
        return false;
      },
      coverFileChange(file, fileList) {
        console.log('fileList', fileList)
        this.coverList = [];
        this.coverList.push(file)
        if (file.status === 'ready') {
          // 当文件状态为 ready 时，生成预览 URL
          const reader = new FileReader();
          reader.onload = (e) => {
            this.coverUrl = e.target.result;
          };
          reader.readAsDataURL(file.raw);
        }
      },
      mainFileChange(file, fileList) {
        console.log('main', fileList)
        this.fileList = [];
        this.fileList.push(file)
        if (file.status === 'ready') {
          // 当文件状态为 ready 时，生成预览 URL
          const reader = new FileReader();
          reader.onload = (e) => {
            this.mainUrl = e.target.result;
          };
          reader.readAsDataURL(file.raw);
        }
      },
      hoverFileChange(file, fileList) {
        console.log('hover', fileList)
        this.hoverList = [];
        this.hoverList.push(file)
        if (file.status === 'ready') {
          // 当文件状态为 ready 时，生成预览 URL
          const reader = new FileReader();
          reader.onload = (e) => {
            this.hoverUrl = e.target.result;
          };
          reader.readAsDataURL(file.raw);
        }
      },
      //删除图片
      delPic(index, id) {
        delPicInfo(id).then(res => {
          if (res.data == 'ok') {
            this.picList.splice(index, 1);
          }
        })

      },
      //查询
      searchProduct(){
        var strWhere=''
        if (this.searchCode!='') {
          strWhere=` and a.code like'%${this.searchCode}%'`
        }
        this.loadDataList(strWhere)
        this.currentPage=1
      },
    },
    computed: {
      // 计算属性，用于获取当前页的数据
      paginatedData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        return this.dataList.slice(start, end);
      },
    },
  }
</script>
<style scoped>
  /* .editTable td{
   padding-left: 10px;
   padding-right: 0px;
   text-align: right;
  } */
  :deep(.el-select main-select-tree) {
    width: 200px !important
  }

  .lableTd {
    text-align: right;
    padding-left: 5px;
    padding-right: 5px;
  }

  /* .editTable input{
   width: 200px;
   margin: 0;
  } */

  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 45px;
  }

  .el-aside {
    color: #333;
  }

  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-content {
    background: #545C64;
    padding: 20px;
    border-radius: 8px;
    min-width: 350px;
    margin-top: 10px;
    max-width: 1200px;
    max-height: 850px;
    overflow: auto;
  }

  .form-group {
    margin-bottom: 15px;
    text-align: left;
  }

  .form-group label {
    display: block;
    width: 200px;
    margin-bottom: 5px;
  }

  .form-group input {
    width: 260px;
  }

  .button-group {
    margin-top: 15px;
    text-align: right;
  }

  .button-group button {
    margin-left: 10px;
  }

  /* :deep(.el-table__inner-wrapper::before) {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0;
}
.custom-table .el-table__body-wrapper {
  border-bottom: none !important;
}
::v-deep .el-table::before {
  background-color: transparent !important;
  height: 0 !important;
} */
  .el-table::before {
    background-color: transparent !important;
    height: 0 !important;
  }

  .custom-table .el-table__row {
    /* 设置最大行高 */
    max-height: 50px;
    /* 可选：设置行内溢出时的显示方式 */
    overflow: hidden;
  }

  /* 如果需要更精细地控制单元格内容，可以针对单元格进行样式设置 */
  .custom-table .el-table__cell {
    /* 限制单元格内容的最大高度，并处理溢出 */
    max-height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 可选：当内容溢出时显示省略号 */
    white-space: nowrap;
    /* 可选：防止文本换行 */
  }

  .el-table__cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cell-ellipsis {
    max-height: 40px;
    /* 设置最大高度 */
    overflow: hidden;
    /* 隐藏超出部分 */
    text-overflow: ellipsis;
    /* 用省略号表示超出文本 */
    display: -webkit-box;
    /* 使用 flexbox 布局 */
    -webkit-line-clamp: 2;
    /* 限制显示的行数 */
    -webkit-box-orient: vertical;
    /* 垂直方向排列 */
    line-height: 20px;
    /* 设置行高 */
  }
  :deep(.el-input__inner){
    height: 30px !important;
    line-height: 30px;
  }
</style>